<template>
  <v-app>
    <v-app-bar
      app
      color="#323a81"
      dark
    >
      <div class="d-flex align-center">
        <v-img
          class="mx-2"
          :src="require('./assets/agenda-free-no-background.png')"
          max-height="70"
          max-width="70"
          contain
        ></v-img>
        Agenda Free TV
      </div>

      <v-spacer></v-spacer>
      <v-btn target="window" text href="https://www.paypal.com/donate/?cmd=_s-xclick&hosted_button_id=XXUKLNXKHXAGL">Donate</v-btn>
    </v-app-bar>

    <v-main>
      <Home/>
    </v-main>
  </v-app>
</template>

<script>
import Home from './components/Home';

export default {
  name: 'App',

  components: {
    Home,
  },

  data: () => ({
    //
  }),
};
</script>
